import { render, staticRenderFns } from "./playerDetails_yujian.vue?vue&type=template&id=0864fad0&scoped=true&"
import script from "./playerDetails_yujian.vue?vue&type=script&lang=js&"
export * from "./playerDetails_yujian.vue?vue&type=script&lang=js&"
import style0 from "./playerDetails_yujian.vue?vue&type=style&index=0&id=0864fad0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0864fad0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0864fad0')) {
      api.createRecord('0864fad0', component.options)
    } else {
      api.reload('0864fad0', component.options)
    }
    module.hot.accept("./playerDetails_yujian.vue?vue&type=template&id=0864fad0&scoped=true&", function () {
      api.rerender('0864fad0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/playerDetails_yujian/playerDetails_yujian.vue"
export default component.exports